import { useState, useEffect } from 'react';

export const useOtpLogic = () => {
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [resendTimer, setResendTimer] = useState(0);

  // OTP Timer Effect - strictly handles countdown
  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [resendTimer]);

  // Only updates UI state, NO API CALLS HERE
  const handleSendOtp = (phoneNumber: string) => {
    if (!phoneNumber) return;
    setOtpSent(true);
    setResendTimer(60); 
  };

  // Only updates UI state, NO API CALLS HERE
  // 👇 FIXED: Added underscore to _enteredOtp to ignore unused variable
  const handleVerifyOtp = (_enteredOtp: string) => {
    // Empty because your component handles the actual validation via Axios
  };

  const handleResendOtp = (phoneNumber: string) => {
    handleSendOtp(phoneNumber);
  };

  return {
    otpSent,
    setOtpSent,
    otp,
    setOtp,
    resendTimer,
    handleSendOtp,
    handleVerifyOtp,
    handleResendOtp,
  };
};